<!--
 * @Descripttion: 项目信息确认函
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <BaseDialog title="项目信息确认函">
    <BaseTextContent>
      <div class="req-center">
        <div
          class="req-center__phone"
          :style="{ left: isReject ? 0 : 'calc(50% - 150px)' }"
        >
          <iframe
            ref="iframeRef"
            :src="previewUrl"
            frameborder="0"
            width="375px"
            height="670px"
          ></iframe>
        </div>
        <div v-if="isReject" class="req-center__code">
          <p style="margin-bottom: 10px">已驳回</p>
          <BaseInput
            style="width: 300px"
            type="textarea"
            :rows="10"
            disabled
            :model-value="detailData.rejectReson"
          ></BaseInput>
        </div>
      </div>
    </BaseTextContent>

    <template #footer>
      <BaseButton type="default" @click="onClose">关闭</BaseButton>
      <BaseButton v-if="isAsp && !isReject" @click="onReject">驳回</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { computed, withDefaults, defineProps } from 'vue';
import {
  BaseButton,
  BaseDialog,
  BaseTextContent,
  BaseInput,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import { PROJECT_CONFIRM_URL } from '@/common/constants/webview/index';
import { letterReject } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    detailData: {
      letterId: number;
      rejectReson: string;
      auditStatus: 1 | 2 | 3; // 审核状态1审核中2审核通过3审核未通过
    };
    remove?: () => void;
    isAsp: boolean;
    projectId: number;
    userId: number;
  }>(),
  {}
);

const previewUrl = computed(() => {
  return `${PROJECT_CONFIRM_URL}?projectId=${props.projectId}&userId=${props.userId}`;
});

const isReject = computed(() => {
  return props.detailData.auditStatus === 3;
});

const onClose = () => {
  props.remove?.();
};

const onReject = async () => {
  const data = await XrkMessageBox.prompt('请输入驳回原因', '驳回原因', {
    cancelButtonText: '取消',
    confirmButtonText: '确定',
    inputValidator: val => {
      if (!val) return '请输入驳回原因';
      if (val.length > 50) return '驳回原因不能超过50个字符';
    },
    inputType: 'textarea',
    inputErrorMessage: '请输入驳回原因'
  });

  await letterReject({
    letterId: props.detailData.letterId,
    rejectReason: data.value
  });
  XrkMessage.success('操作成功');
  onClose();
};
</script>

<style lang="scss" scoped>
.req-center {
  flex: 1;
  box-sizing: border-box;
  padding: 30px 28px;
  display: flex;
  position: relative;
  height: 600px;
  width: 700px;

  .req-center__phone {
    position: absolute;
    top: 0;
    box-sizing: border-box;
    padding: 66px 32px;
    background-image: url(../../../../assets/手机框.png);
    background-size: 100% 100%;
    transform: scale(0.7);
    transform-origin: top left;
  }
  .req-center__code {
    position: absolute;
    top: 0;
    right: 0;
    margin-left: 16px;
  }
}
</style>
